(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewViolations.controller:CrewViolationsCtrl
   *
   * @description
   *
   */
  angular
    .module('crewViolations')
    .controller('CrewViolationsCtrl', CrewViolationsCtrl);

  function CrewViolationsCtrl(CommonMasterData, crewViolationsService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'CrewViolationsCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      pagination: {
        currentPage: 1,
        pageSize: 100,
        totalPages: 0,
        totalRecords: 0
      },
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        aircraftType: null,
        blankDaysOnly: false,
        showCrewExpiries: false,
        autoOrManual : null,
        ruleClassificationTypes: null

      },
      masterList: {
        crewTypeList: [],
        aircraftTypes: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}],
        ruleClassificationTypes : []

      },
      lastSearchDates:{
    	  fromDate:null,
    	  toDate:null
      },
      crewViolationsList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.allPagesFetched = false;

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params, pageNumber) {

      if (angular.isUndefined(pageNumber)) {
        vm.prefetchedData = {};
        vm.allPagesFetched = false;
        pageNumber = 1
      }

      if (!pageNumber) {
        vm.model.pagination.currentPage = 1;
      }

      if(vm.prefetchedData[pageNumber]){
        vm.model.crewViolationsList = vm.prefetchedData[pageNumber];
        vm.model.pagination.currentPage = pageNumber;

        renderTable();
      }else{
        crewViolationsService.searchCrewViolations(params, vm.model.pagination.currentPage, vm.model.pagination.pageSize,true,
          function (response) {

            vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
            vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
            vm.model.crewViolationsList = response.crewViolationResponseDTOS;
            vm.prefetchedData[pageNumber] = response.crewViolationResponseDTOS;
            vm.model.searchPanelToggle = false;

            // Update pagination metadata from response
            vm.model.pagination.totalRecords = response.totalRecords || 0;
            vm.model.pagination.totalPages = response.totalPages || 0;
            vm.model.pagination.currentPage = response.currentPage || 1;
            vm.model.pagination.pageSize = response.pageSize || 100;
            vm.model.totalNumberOfRecords = response.totalRecords || 0;

            isAllPagesFetched();
            renderTable();
            prefetchNextPages();
          },
          function (error) {
            MessageService.error(error[0]);
          }
        );
      }
    };

    function renderTable() {
      dataObject = vm.dataObject();
      hotSettings = vm.hotSettings();
      hot = new Handsontable(hotElement, hotSettings);
      $compile(hotElement)($scope);
    }

    function prefetchNextPages() {
      let totalPages = vm.model.pagination.totalPages;
      let currentPage = vm.model.pagination.currentPage;
      let pageSize = vm.model.pagination.pageSize;
      let params = vm.model.searchCriteria;
      for (let page = currentPage + 1; page <= totalPages; page++) {
        if( !vm.prefetchedData[page]){
          crewViolationsService.searchCrewViolations(
            params,
            page,
            pageSize,
            false,
            function (response) {
              vm.prefetchedData = vm.prefetchedData || {};
              vm.prefetchedData[page] = response.crewViolationResponseDTOS;
              isAllPagesFetched();
            },
            function () {
              console.warn("Failed to prefetch page: " + page);
            }
          );
        }
      }
    }

    function isAllPagesFetched () {
    // Check if all pages are now fetched
    if (Object.keys(vm.prefetchedData).length === vm.model.pagination.totalPages) {
      vm.allPagesFetched = true;
      console.log("All pages fetched. Export enabled.");
    }
  }

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.crewViolationsList) {
        dataObject.push({
          ROW_NUMBER : ((vm.model.pagination.currentPage-1) * vm.model.pagination.pageSize) + parseInt(i) + 1,
          CREW_NAME: populateCrewNameHyperLink(vm.model.crewViolationsList[i]),
          CREW_ID: vm.model.crewViolationsList[i].crewID,
          BLOCK_NAME: vm.model.crewViolationsList[i].blockName,
          BLOCK_START_DATE_TIME: vm.model.crewViolationsList[i].blockStartDateTime,
          VIOLATION_TYPE: populateViolationTypeWithColor(vm.model.crewViolationsList[i].violationType),
          RULE_CLASSIFICATION: vm.model.crewViolationsList[i].violatedRuleClassificationDescription,
          REASON: vm.model.crewViolationsList[i].violatedReason,
          AUTO: vm.model.crewViolationsList[i].autoOrManual,
        })
      }
      return dataObject;
    };

    function populateCrewNameHyperLink(data){
    	var str = '<a ';
    	return str.concat('ng-click=\'crewViolations.crewNameHyperLinkClick(\"',data.crewID,',',data.blockStartDateTime
,'\")\'','>', data.crewName, '</a>');
    }

    function populateViolationTypeWithColor(violationType) {
      var color;
      if (violationType === "Violation") {
        color = 'red';
      } else if (violationType === "Expiries") {
        color = 'blue';
      } else if (violationType === "Warning") {
        color = 'orange';
      } else {
        color = 'black'; // Default color if needed
      }
      var str = '<span style="color: ' + color + ';">' + violationType + '</span>';
      return str;
    }

    vm.crewNameHyperLinkClick = function(data){

    	var dataArr = data.split(",");
    	var crewID = dataArr[0];
    	var blockStartDate = (!!dataArr[1] && dataArr[1].length > 10) ? dataArr[1].substring(0,10) : vm.model.lastSearchDates.fromDate;

    	var tabName = 'crewSchedule'
    	var date = moment(blockStartDate, applicationConstants.SETTINGS.DATE_FORMAT);
    	var moStart = date.clone().startOf("month");
    	var moEnd = date.clone().endOf("month");
    	StorageServices.setTabData(tabName, 'crewingParams', {
	        crewId: crewID,
	        fromDate: moStart.format(applicationConstants.SETTINGS.DATE_FORMAT),
	        toDate: moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT)
    	});

	    TabService.gotoTab(tabName, {
	        crewId: crewID,
	        time: (new Date()).getMilliseconds()
	    });

    }

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.025, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.3, vm.model.width * 0.1, vm.model.width * 0.1],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          },
          {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },  {
            data: 'BLOCK_NAME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLOCK_START_DATE_TIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'VIOLATION_TYPE',
            renderer: 'html',
            readOnly: true
          },
          {
            data: 'REASON',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RULE_CLASSIFICATION',
            renderer: 'html',
            readOnly: true
          },
          {
            data: 'AUTO',
            type: 'text',
            readOnly: true
          }
          ],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.7,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Block Name',
          'Block Start Date Time',
          'Alert Category',
          'Reason',
          'Rule Classification',
          'Auto/Manual'
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    // Pagination functions
    vm.goToPage = function (pageNumber) {
      if (pageNumber >= 1 && pageNumber <= vm.model.pagination.totalPages) {
        vm.model.pagination.currentPage = pageNumber;
        vm.submitSearch(vm.model.searchCriteria, pageNumber);
      }
    };

    vm.nextPage = function () {
      if (vm.model.pagination.currentPage < vm.model.pagination.totalPages) {
        vm.goToPage(vm.model.pagination.currentPage + 1);
      }
    };

    vm.prevPage = function () {
      if (vm.model.pagination.currentPage > 1) {
        vm.goToPage(vm.model.pagination.currentPage - 1);
      }
    };

    vm.firstPage = function () {
      vm.goToPage(1);
    };

    vm.lastPage = function () {
      vm.goToPage(vm.model.pagination.totalPages);
    };

    vm.getPageNumbers = function () {
      var pages = [];
      var startPage = Math.max(1, vm.model.pagination.currentPage - 2);
      var endPage = Math.min(vm.model.pagination.totalPages, vm.model.pagination.currentPage + 2);

      for (var i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    };

    vm.getRecordRangeTo = function () {
      return Math.min(vm.model.pagination.currentPage * vm.model.pagination.pageSize, vm.model.pagination.totalRecords);
    };

    // Excel Export functionality
    vm.exportExcel = function () {
      var exportList = createExportList();

      alasql(
        "SELECT [rowNumber] AS [#], [crewName] AS [Crew Name], [crewId] AS [Crew Id], [blockName] AS [Block Name], [blockStartDateTime] AS [Block Start Date Time], [violationType] AS [Alert Category], [ruleClassification] AS [Rule Classification], [reason] AS [Reason], [autoManual] AS [Auto/Manual] INTO XLSX('crew_violations.xlsx',{headers:true}) FROM ?",
        [exportList]
      );

    };

    function createExportList() {
      var exportList = [];

      // Get all data from prefetched pages in order
      for (var page = 1; page <= vm.model.pagination.totalPages; page++) {
        var pageData = vm.prefetchedData[page];
        if (!!pageData && pageData.length > 0) {
          for (var i = 0; i < pageData.length; i++) {
            var item = pageData[i];
            var exportItem = {
              rowNumber: ((page - 1) * vm.model.pagination.pageSize) + i + 1,
              crewName: item.crewName || '',
              crewId: item.crewID || '',
              blockName: item.blockName || '',
              blockStartDateTime: item.blockStartDateTime || '',
              violationType: item.violationType || '',
              ruleClassification: item.violatedRuleClassificationDescription || '',
              reason: item.violatedReason || '',
              autoManual: item.autoOrManual || ''
            };
            exportList.push(exportItem);
          }
        }
      }

      return exportList;
    }

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterList.aircraftTypes = airCraftList;
      }, function () {
        console.log('Aircraft type retrieval error');
      });

      CommonMasterData.getRuleClassificationTypes(function (ruleClassificationTypes) {
        vm.model.masterList.ruleClassificationTypes = ruleClassificationTypes;
      }, function () {
        console.log('Rule Classification types retrieval error');
      });

    })();

  }
}());
